<template>
 <div>
    <div class="container">
      <div class="letsfigure-title">
        <h2>Let’s figure out how much you can afford</h2>
        <p>Before you start shopping, let’s figure out how much you can afford. Move the sliders to see how the loan duration and the total loan amount affect your monthly payments.</p>
      </div>
      <div class="letsfigure-main">
        <div class="letsfigure-main_left">
          <div class="left_buttons">
            <button class="button-lestfigure1 button" :class="{btnactive: actBTN === 'btn1'}"  @click="inputMaxPoor">Poor</button>
            <button class="button-lestfigure2 button" :class="{btnactive: actBTN === 'btn2'}" @click="inputMaxAverage">Average</button>
            <button class="button-lestfigure3 button" :class="{btnactive: actBTN === 'btn3'}" @click="inputMaxGood">Good</button>
          </div>
          <div class="left_loan-amount">
            <div class="loan-amount_top">
              <h4>Loan Amount</h4>
              <span>$ {{loanAmount}}</span>
            </div>
            <div class="loan-amount_range">
              <input type="range" min="10000" :max="max" step="1000"
              v-model='loanAmount'
              @input="updateSlider2" :style="{backgroundSize: backgroundSize2}">
            </div>
          </div>
          <div class="left_loan-amount">
            <div class="loan-amount_top">
              <h4>Loan Duration</h4>
              <span>{{loanDuratin}} <span>month</span></span>
            </div>
            <div class="loan-amount_range">
              <input type="range" min="6" max="60" step="2"
              v-model='loanDuratin'
              @input="updateSlider" :style="{backgroundSize: backgroundSize}">
            </div>
          </div>
          
        </div>
        <div class="letsfigure-main_right">
          <div class="right-wrapper">
            <div class="right-main">
              <h5>Bi-Weekly Payment</h5>
              <span class="right-main_big">$ {{ uptadeBiWeeklyPayment }}</span>
            </div>
            <div class="right-main_bottom">
              <div class="right-main">
                <h5>Monthly Payment</h5>
                <span class="right-main_small" >$ {{ uptadeMonthlyPayment }}</span>
              </div>
              <div class="right-main">
                <h5>Weekly Payment</h5>
                <span class="right-main_small">$ {{ uptadeWeeklyPayment }}</span>
              </div>
            </div>
          </div>
          <router-link to="/Request" class="letsfigure-require">Request a car</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      loanAmount: 30000,
      loanDuratin: 16,
      BiWeeklyPayment: null,
      MonthlyPayment: null,
      WeeklyPayment: null,
      backgroundSize: '18.5185% 100%',
      backgroundSize2: '22.2222% 100%',
      max: 100000,
      actBTN: 'btn1',
    }
  },

  methods: {
     updateSlider(e) {
            let clickedElement = e.target,
                min = clickedElement.min,
                max = clickedElement.max,
                val = clickedElement.value;

            this.backgroundSize = (val - min) * 100 / (max - min) + '% 100%';
     },
     updateSlider2(e) {
            let clickedElement = e.target,
                min = clickedElement.min,
                val = clickedElement.value;
                //left = (val - min) * 100 / (this.max - min) + '%';
                console.log(val, this.max, min)
                if(this.max === 60000){
                  this.backgroundSize2 = (val - min) * 100 / (60000 - min) + '% 100%';
                }
            this.backgroundSize2 = (val - min) * 100 / (this.max - min) + '% 100%';
     },
     inputMaxPoor(){
      this.actBTN = 'btn1'
      this.loanAmount = 30000
      this.loanDuratin = 16
      this.backgroundSize2 = '22.2222% 100%'
      this.backgroundSize = '18.5185% 100%'
      //this.max = 60000;
      // if(this.backgroundSize2 == '100% 100%'){
      //   this.loanAmount = this.max
      // }
     },
     inputMaxAverage(){
      this.actBTN = 'btn2'
      this.loanAmount = 60000
      this.loanDuratin = 30
      this.backgroundSize2 = '55.5556% 100%'
      this.backgroundSize = '44.4444% 100%'
      //this.max = 80000;
      // if(this.backgroundSize2 == '100% 100%'){
      //   this.loanAmount = this.max
      // }
     },
     inputMaxGood(){
      this.actBTN = 'btn3'
      this.loanAmount = 90000
      this.loanDuratin = 46
      this.backgroundSize2 = '88.8889% 100%'
      this.backgroundSize = '74.0741% 100%'
      //this.max = 100000;
      // if(this.backgroundSize2 == '100% 100%'){
      //   this.loanAmount = this.max
      // }
     }
     
   },

   computed: {
      uptadeMonthlyPayment: function(){
        return this.MonthlyPayment = Math.round(this.loanAmount / this.loanDuratin);
      }, 
      uptadeBiWeeklyPayment: function(){
        return this.BiWeeklyPayment = Math.round((this.loanAmount / this.loanDuratin) / 2);
      },
      uptadeWeeklyPayment: function(){
        return this.WeeklyPayment = Math.round((this.loanAmount / this.loanDuratin) / 4);
      }
    },

    watch: {
      // max(newValue){
      //   console.log(newValue)
      // },
      updateSlider2(){
        this.max = !this.max
      }
    },
}
</script>
<style lang="scss">

@import '../assets/scss/breakpoints.scss';

                                                  //LETSFIGURE


.letsfigure {
  margin-top: 220px;
  @include breakpoints(md){
    margin-top: 160px;
  }
  @include breakpoints(sm){
    margin-top: 80px;
  }
}
.calculator{
    margin: 40px 0;
    @include breakpoints(sm){
        margin: 30px 0;
    }
}
.margin-bottom{
  margin-bottom: 40px;
  @include breakpoints(sm){
    margin-bottom: 30px;
  }
}
.letsfigure-title {
  display: flex;
  justify-content: space-between;
  @include breakpoints(md){
    flex-direction: column;
    gap: 20px;
  }
  @include breakpoints(sm){
    gap: 10px;
  }

  h2{
    font-family: 'Gilroy700';
    font-size: 45px;
    line-height: 140.5%;
    color: #41456B;
    width: 40%;
    @include breakpoints(lg){
      width: 50%;
    }
    @include breakpoints(md){
      width: 100%;
    }
    @include breakpoints(sm){
      font-size: 30px;
    }
  }

  p{
    font-family: 'Gilroy400';
    font-size: 16px;
    line-height: 180%;
    letter-spacing: 0.02em;
    color: #606276;
    width: 50%;
    padding-top: 10px;
    @include breakpoints(lg){
      width: 40%;
    }
    @include breakpoints(md){
      width: 100%;
    }
  }
}
.letsfigure-main {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  @include breakpoints(lg){
    flex-direction: column;
  }
  @include breakpoints(sm){
    margin-top: 30px;
  }
}
.letsfigure-main_left {
  display: flex;
  flex-direction: column;
  gap: 60px;
  padding: 60px 60px 112px 60px;
  width: 65%;
  background: #FFFFFF;
  box-shadow: 0px 20px 25px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  @include breakpoints(lg){
    width: 100%;
    padding-bottom: 40px;
  }
  @include breakpoints(sm){
    padding: 20px;
    gap: 40px;
  }
}
.left_buttons {
  @include breakpoints(sm){
    display: flex;
    justify-content: center;
  }

  .button-lestfigure1, .button-lestfigure2, .button-lestfigure3{
    font-family: 'Gilroy700';
    font-size: 16px;
    line-height: 14px;
    text-align: center;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #7481FF;;
    border: 1px solid #7481FF;
    padding: 18px 19px;
    background: #FFFFFF;
    transition: all .3s ease;

    @include breakpoints(sm){
      padding: 11px 14px;
    }
  }
  .button-lestfigure1{
    border-radius: 2px 0 0 2px;
    border: 1px solid #7481FF;
    border-right: 0px;
  }
  .button-lestfigure2{
    border: 1px solid #7481FF;
    border-right: 0px;
  }
  .button-lestfigure3{
    border-radius: 0 2px 2px 0;
    border: 1px solid #7481FF;
  }

  .btnactive{
    background: #7481FF;
    color:#FFFFFF;
    transition: all .5s ease;
  }
}


.left_loan-amount {
  display: flex;
  flex-direction: column;
  gap: 30px;
  @include breakpoints(sm){
    gap: 20px;
  }
}
.loan-amount_top {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h4{
    font-family: 'Gilroy600';
    font-size: 20px;
    line-height: 25px;
    color: #41456B;
    @include breakpoints(sm){
      font-size: 18px;
    }
  }

  span{
    font-family: 'Gilroy700';
    font-size: 25px;
    line-height: 140%;
    letter-spacing: 0.02em;
    color: #41456B;
    display: flex;
    align-items: baseline;
    gap: 5px;
    @include breakpoints(sm){
      font-size: 20px;
    }

    span{
      font-family: 'Gilroy700';
      font-size: 16px;
      line-height: 14px;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      color: #606276;

    }
  }
}
.loan-amount_range {
  input{
    cursor: pointer;
    -webkit-appearance: none;
    width: 100%;
    height: 8px;
    background: #D7D7D7;
    border-radius: 2px;
    outline: none;
    border: none;
    background-image: -webkit-gradient(linear, 0% 0%, 0% 0%, color-stop(0%, #7481FF), color-stop(100%, #7481FF));
    background-image: -webkit-linear-gradient(left, #7481FF 0%,#7481FF 100%);
    background-image: -moz-linear-gradient(left, #7481FF 0%, #7481FF 100%);
    background-image: -o-linear-gradient(to right, #7481FF 0%,#7481FF 100%);
    background-image: linear-gradient(to right, #7481FF 0%,#7481FF 100%);
    background-repeat: no-repeat;

    &::-webkit-slider-thumb{
      -webkit-appearance: none;
      width: 18px;
      height: 18px;
      background: #7481FF;
      border: 1px solid #FFFFFF;
      border-radius: 2px;
      cursor: pointer;
    }
  }
}


.letsfigure-main_right {
  width: 30%;
  background: #FFFFFF;
  box-shadow: 0px 20px 25px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 60px;
  @include breakpoints(lg){
    width: 100%;
    margin-top: -5px;
    padding-top: 0;
  }
  @include breakpoints(sm){
    padding: 40px 20px 20px 20px;
  }
}
.right-wrapper {
  display: flex;
  flex-direction: column;
  @include breakpoints(lg){
    flex-direction: inherit;
    justify-content: space-between;
  }
  @include breakpoints(sm){
    flex-direction: column;
  }
}
.right-main_bottom{
  display: flex;
  flex-direction: column;
  gap: 20px;
  @include breakpoints(lg){
    flex-direction: inherit;
    gap: 40px;
  }
   @include breakpoints(sm){
    flex-direction: initial;
    justify-content: space-between;
    gap: 1px;
  }
}
.right-main {
  display: flex;
  flex-direction: column;
  gap: 1px;

  h5{
    font-family: 'Gilroy400';
    font-size: 16px;
    line-height: 180%;
    letter-spacing: 0.02em;
    color: #606276;
  }
}
.right-main_big {
  font-family: 'Gilroy700';
  font-size: 45px;
  line-height: 140.5%;
  color: #7481FF;
  padding-bottom: 30px;
   @include breakpoints(sm){
    padding-bottom: 10px;
    font-size: 35px;
  }
}
.right-main_small {
  font-family: 'Gilroy700';
  font-size: 25px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #41456B;
  @include breakpoints(sm){
    font-size: 20px;
  }
}
.letsfigure-require {
  font-family: 'Gilroy700';
  font-size: 16px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #FFFFFF;
  background: #7481FF;
  border-radius: 2px;
  padding: 15px 0 16px;
  width: 100%;
  margin-top: 40px;
  display: block;
   @include breakpoints(sm){
    padding: 10px 0;
  }
}

</style>